import { render, staticRenderFns } from "./BCXMessengerConversations.vue?vue&type=template&id=516115fe&scoped=true"
import script from "./BCXMessengerConversations.vue?vue&type=script&lang=ts"
export * from "./BCXMessengerConversations.vue?vue&type=script&lang=ts"
import style0 from "./BCXMessengerConversations.vue?vue&type=style&index=0&id=516115fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516115fe",
  null
  
)

export default component.exports